import { FileText, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'

/** No claims on the account — the state most customers are in, and hope to stay in. */
export function ClaimsEmptyState() {
  return (
    <div className="border-ink-200 bg-surface flex flex-col items-center rounded-md border px-6 py-12 text-center">
      <FileText className="text-ink-300 size-6" />
      <p className="mt-3 text-sm font-semibold">No claims yet</p>
      <p className="text-ink-500 mt-1 max-w-xs text-sm">
        If something happens on the road, report it here and we will take it from there.
      </p>
      <Button size="sm" className="mt-4">
        <Plus />
        Report a claim
      </Button>
    </div>
  )
}
